import { SecondaryMarketPostEventWorkspace } from 'components/Workspaces/SecondaryMarketPostEvent';

export default SecondaryMarketPostEventWorkspace;
